export default __webpack_public_path__ + "static/media/jp.574002df.svg";